import classNames from 'classnames'
import Link, { LinkProps } from 'next/link'

type TabListItemLinkProps = {
  id: string
  tabordionId: string
  tabTypeClassName: string
  isActive: boolean
  isLink: boolean
  title: string
} & LinkProps
export const TabListItemLink = ({
  id,
  tabordionId,
  tabTypeClassName,
  isActive,
  isLink,
  title,
  ...props
}: TabListItemLinkProps) => {
  return (
    <Link
      {...props}
      id={`tab-${id}-${tabordionId}`}
      className={classNames(`${tabTypeClassName}__tab-btn`, {
        [`${tabTypeClassName}__tab-btn--active`]: isActive,
        [`${tabTypeClassName}__tab-btn--link`]: isLink,
      })}
      aria-controls={`tab-pane-${id}-${tabordionId}`}
      tabIndex={isActive ? 0 : -1}
      aria-selected={isActive}>
      <span className="d-block u-h-100" data-bold-placeholder={title}>
        {title}
      </span>
    </Link>
  )
}

type TabListItemProps = {
  id?: string
  tabIndex?: number
  className?: string
  style?: any
  onKeyDown?: any
  children?: React.ReactNode
}
export const TabListItem = ({
  id,
  tabIndex,
  className,
  style,
  onKeyDown,
  children,
}: TabListItemProps) => (
  <li
    id={id}
    tabIndex={tabIndex}
    onKeyDown={onKeyDown ? onKeyDown : undefined}
    className={className}
    style={style}
    role="tab">
    {children}
  </li>
)
type TabListProps = {
  tabTypeClassName: string
  sticky?: boolean
  children: React.ReactNode
}
export const TabList = ({ tabTypeClassName, sticky, children }: TabListProps) => (
  <ul
    role="tablist"
    className={classNames(`${tabTypeClassName}__menu`, { 'container u-px-16': sticky })}>
    {children}
  </ul>
)

type ContentSectionProps = {
  tabTypeClassName: string
  noContentPadding: boolean
  mega: boolean
  children: React.ReactNode
}
export const ContentSection = ({
  tabTypeClassName,
  noContentPadding,
  mega,
  children,
}: ContentSectionProps) => (
  <div
    className={classNames(`${tabTypeClassName}__content`, {
      'u-py-0 u-px-0': noContentPadding && !mega,
    })}>
    {children}
  </div>
)

type ContentWrapperProps = {
  idx: number
  tabordionId: string
  isActive: boolean
  tabTypeClassName: string
  children: React.ReactNode
}
// data-hj-ignore-attributes is for hotjar not being able to track clicks with a dynamic id
export const ContentWrapper = ({
  idx,
  tabordionId,
  isActive,
  tabTypeClassName,
  children,
}: ContentWrapperProps) => (
  <div
    id={`tab-pane-${idx}-${tabordionId}`}
    className={classNames(`${tabTypeClassName}__pane`, {
      [`${tabTypeClassName}__pane--active`]: isActive,
    })}
    role="tabpanel"
    aria-labelledby={`tab-${idx}-${tabordionId}`}
    data-hj-ignore-attributes>
    {children}
  </div>
)
